export default "__VITE_ASSET__PsW7FhLT__"